import { render, staticRenderFns } from "./SumniConfig.vue?vue&type=template&id=be73a48c"
import script from "./SumniConfig.vue?vue&type=script&lang=js"
export * from "./SumniConfig.vue?vue&type=script&lang=js"
import style0 from "./SumniConfig.vue?vue&type=style&index=0&id=be73a48c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports